<template>
  <div
    class="folder-card"
    ref="container"
    :class="[colorClass, selected ? 'selected' : '']"
    onclick="document.videoPlayer.play();"
  >
    <div class="placeholder">
      <div class="wrap">
        <div class="img-wrap">
          <img class="image" :src="item.imageUrl" alt="Item Image"
          :class="isLocked ? 'image-mask' : ''"/>
        </div>
        <span v-if="hasValidDuration" class="duration">{{ formattedDuration }}</span>
        <div v-show="isLocked" class="lock-container">
          <div class="loc-icon">
            <svg viewBox="0 0 139 139" xmlns="http://www.w3.org/2000/svg">
              <g>
                <title>background</title>
                <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/>
              </g>
              <g>
                <title>Layer 1</title>
                <path fill="#ffffff" id="svg_1" d="m109.92,59.988c0.426,-2.44 0.661,-4.95 0.661,-7.516c0,-23.326 -18.429,-42.305 -41.081,-42.305c-22.653,0 -41.083,18.979 -41.083,42.305c0,2.566 0.236,5.074 0.663,7.516c-3.567,2.278 -5.939,6.261 -5.939,10.81l0,41.415c0,7.084 5.743,12.826 12.825,12.826l67.067,0c7.08,0 12.822,-5.742 12.822,-12.826l0.004,0l0,-41.415c0,-4.548 -2.37,-8.532 -5.939,-10.81zm-34.761,36.162l0,9c0,3.128 -2.534,5.662 -5.661,5.662c-3.127,0 -5.661,-2.534 -5.661,-5.662l0,-9.004c-3.631,-2.001 -6.094,-5.862 -6.094,-10.302c0,-6.492 5.263,-11.756 11.757,-11.756c6.494,0 11.758,5.264 11.758,11.756c0,4.442 -2.465,8.306 -6.099,10.306zm19.791,-38.179l-50.901,0c-0.349,-1.775 -0.535,-3.616 -0.535,-5.499c0,-15.003 11.657,-27.208 25.986,-27.208c14.328,0 25.984,12.204 25.984,27.208c0,1.883 -0.184,3.724 -0.534,5.499z"/>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="hover-mask"></div>
  </div>
</template>

<script>
  import { CardColor } from '../services/cards.service';
  import langUtil, {StringKey} from '@/utils/lang.util';

  export default {
    name: 'FolderCard',
    props: {
      item: {
        type: Object,
        required: true,
        // DEV NOTE: add validator later
      },
      selected: {
        type: Boolean,
        default: false,
      },
      selectedHeart: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        colorClass: `folder-card-${this.item.color || CardColor.Red}`,
        selectedHeartDefault: false,
        strings: {
          unlock: langUtil.getLang().t(StringKey.Unlock),
          minuteShort: langUtil.getLang().t(StringKey.MinuteShort),
          minutesShort: langUtil.getLang().t(StringKey.MinutesShort),
        },
        aspectRatio: 2.10,
      };
    },
    computed: {
      getPremium() {
        return this.$store.getters['account/getPremium'];
      },
      isLocked() {
        return (this.item.premium || this.item.isLocked) && !this.getPremium;
      },
      hasValidDuration() {
        return (typeof this.item.duration === 'number' && !Number.isNaN(this.item.duration));
      },
      formattedDuration() {
        const duration = Math.ceil(this.item.duration / 60);
        const minutes = duration > 1 ? this.strings.minutesShort : this.strings.minuteShort;

        return `${duration} ${minutes}`;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/styles/breakpoints.scss';

  @mixin transition($transition...) {
    -moz-transition: $transition;
    -o-transition: $transition;
    -webkit-transition: $transition;
    transition: $transition;
  }

  div {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  ::-moz-selection {
    background: transparent;
  }

  ::selection {
    background: transparent;
  }

  .folder-card {
    position: relative;
    box-sizing: border-box;
    border-radius: 24px;
    box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, .4);
    cursor: pointer;
    font-family: 'Nunito-ExtraBold', serif;
    position: relative;
    // margin: 10px;
    outline: none;
    background: white;
    z-index: 1;

    & * { box-sizing: border-box; }

    &:before {
      display: block;
      padding-top: 75%; //DEV NOTE: control the aspect ratio
      content: '';
    }

    @media (orientation: portrait) {
      width: 210px;

      @media (min-width: $breakpoint-2xs) {
        width: 240px;
      }

      @media (min-width: $breakpoint-md) {
        width: 260px;
      }
    }

    @media (orientation: landscape) {
      flex: 0 0 200px;

      @media (min-width: $breakpoint-md) {
        flex: 0 0 220px;
      }

      @media (min-width: $breakpoint-lg) {
        flex: 0 0 265px;
      }
      
      @media (min-width: $breakpoint-xl) {
        flex: 0 0 275px;
      }
    }

    &.selected {
      .hover-mask {
        opacity: 1;
        @include transition(opacity .2s ease);
      }
    }

    &:focus-visible,
    &:focus {
      outline: none;
    }

    .hover-mask {
      background: rgba(255, 255, 255, 0.4);
      border-radius: 24px;
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      width: 100%;

      @media (min-width: $breakpoint-md) {
        &:focus,
        &:hover {
          opacity: 1;
          @include transition(opacity .2s ease);
        }
      }
    }

    .placeholder {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 4px;
    }

    .wrap {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 22px;
      z-index: 0;
    }

    .img-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      overflow: hidden;
    }

    .image {
      display: block;
      height: 100%;
      max-height: 100%;
      &.image-mask {
        filter: grayscale(100%);
      }
    }

    .title {
      position: absolute;
      z-index: 10;
      bottom: 0;
      width: 100%;
      min-height: 80px;
      padding: 0;
      color: white;
      font-size: 14px;
      background: linear-gradient(0deg, rgba(0,0,0,8) 0%, rgba(0,0,0,0) 100%);

      @media (min-width: $breakpoint-md) {
        min-height: 100px;
        font-size: 18px;
      }

      div,
      span {
        position: absolute;
        bottom: 12px;
        left: 16px;

        img { margin-left: 3px; }
      }
    }

    .duration {
      position: absolute;
      z-index: 10;
      top: 10px;
      left: 12px;
      padding: 6px 8px;
      font-size: 12px;
      background-color: rgba(20, 20, 20, 0.8);
      border-radius: 14px;
      color: white;

      @media (min-width: $breakpoint-md) {
        font-size: 16px;
      }
      
      @media (min-width: $breakpoint-xl) {
        font-size: 18px;
      }
    }

    .lock-container {
      position: absolute;
      z-index: 11;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      padding-top: 3px;
      background: #ef5902;
      border-style: solid;
      border-color: white;
      border-width: 4px 0 0 4px;
      border-top-left-radius: 24px;

      svg {
        width: 14px;
        height: 14px;
      }

      @media (min-width: $breakpoint-md) {
        width: 34px;
        height: 34px;
        padding-top: 4px;

        svg {
          width: 18px;
          height: 18px;
        }
      }
      
      @media (min-width: $breakpoint-xl) {
        width: 38px;
        height: 38px;

        svg {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
</style>
